<template>
    <v-card elevation="0">
        <configs-popup-edit-info ref="configs-popup-edit-info"></configs-popup-edit-info>
        <c-edit-tag-popup ref="c-edit-tag-popup"></c-edit-tag-popup>
        <c-edit-group-popup ref="c-edit-group-popup"></c-edit-group-popup>
        <c-p-r-deploy-with-merge-popup ref="c-p-r-deploy-with-merge-popup"></c-p-r-deploy-with-merge-popup>
        <v-card elevation="0">
          <v-card-actions class="ma-0 pa-0 mx-2">
            <v-card width="100%" class="ma-0 pa-0 scroll" elevation="0">
              <c-pre-release-table
                  v-on:show-configs-popup-edit-info="showEditInfoPopup"
                  v-on:show-c-edit-tag-popup="showEditTagPopup"
                  v-on:show-c-edit-group-popup="showEditGroupPopup"
                  v-on:show-c-p-r-deploy-with-merge-popup="showDeployWithMergePopup"
              >
              </c-pre-release-table>
            </v-card>
          </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import CPreReleaseTable from "@/modules/mconfigs/views/pre-release/c-pre-release-table";
import CEditTagPopup from "@/modules/mconfigs/views/pre-release/popups/c-edit-tag-popup";
import CPRDeployWithMergePopup from "@/modules/mconfigs/views/pre-release/popups/c-p-r-deploy-with-merge-popup";
import ConfigsPopupEditInfo from "@/modules/mconfigs/views/popups/configs-popup-edit-info";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import CEditGroupPopup from "@/modules/mconfigs/views/pre-release/popups/c-edit-group-popup.vue";

export default {
    name: "c-pre-release",
    components: {
      CEditGroupPopup,
      ConfigsPopupEditInfo, CPRDeployWithMergePopup, CPreReleaseTable, CEditTagPopup},
    data: () => ({
    }),
    methods:{
        showEditInfoPopup(config){
            this.$refs['configs-popup-edit-info'].show(config, function (config, newInfo) {
                let copy = config.clone()
                copy.info = newInfo
                ConfigStoreUtils.updateReleaseConfig(copy, null)
                    .then(() => {
                        this.$notify({title: 'Info successfully changed!', text: "", type: "success"});
                    }).catch((error) => {
                    this.$notify({title: 'Info change failed!', text: error, type: "error"});
                })
            })
        },
        showDeployWithMergePopup(item){
            this.$refs['c-p-r-deploy-with-merge-popup'].show(item)
        },
        showEditTagPopup(item){
            this.$refs['c-edit-tag-popup'].show(item)
        },
        showEditGroupPopup(item){
          this.$refs['c-edit-group-popup'].show(item)
        },
    },
    computed: {
      winsize() {
        return window.app.winsize;
      }
    },
}
</script>

<style scoped>

</style>